export default __webpack_public_path__ + "static/media/cmi.f76782fe.png";